import { Icon } from "~/components/icon";
import { useCopyToClipboard } from "~/hooks/useCopyToClipboard";

function NoWrap({ children }: { children: React.ReactNode }) {
  return <span className="whitespace-nowrap">{children}</span>;
}

export function KubectlCopyCommand({ operationId }: { operationId: string }) {
  const [copiedText, copy, resetCopiedText] = useCopyToClipboard();
  const kubectlCommand = `kubectl patch -n turbopuffer turbopufferoperation/${operationId} --type=merge --patch='{"spec": {"approved": true}}'`;

  const handleCopy = async () => {
    const success = await copy(kubectlCommand);
    if (success) {
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        resetCopiedText();
      }, 2000);
    }
  };

  return (
    <div className="group relative mb-2">
      <div
        className="cursor-pointer space-y-1 rounded bg-gray-900 p-2 pr-10 text-xs text-gray-300 transition-colors hover:bg-gray-800"
        onClick={handleCopy}
      >
        kubectl patch -n turbopuffer turbopufferoperation/{operationId}{" "}
        <NoWrap>--type=merge</NoWrap>{" "}
        <NoWrap>{`--patch='{"spec": {"approved": true}}'`}</NoWrap>
      </div>
      <button
        onClick={handleCopy}
        className="absolute right-2 top-2 rounded p-1 transition-colors hover:bg-gray-700"
        title={copiedText === kubectlCommand ? "Copied!" : "Copy command"}
      >
        <Icon
          name={copiedText === kubectlCommand ? "Check" : "Copy"}
          size={14}
          className={
            copiedText === kubectlCommand
              ? "text-green-400"
              : "text-gray-400 hover:text-gray-200"
          }
        />
      </button>
    </div>
  );
}
